import dotEnv from "dotenv";
import { createOfferContractTypes, customerDocsContractTypes, listingContractTypes, otherDocsContractTypes } from "../commondata/commonData";
dotEnv.config();
const { detectWebView, getValuesFromCookies, decryptUrlParams, encryptUrlParams, buildQueryString, getCategoryDataHandle, getPrimaryClientId } = require("../utils/universalFuntions");
const apiURL = process.env.REACT_APP_WEB_BASE_URL;
const adminApiURL = process.env.REACT_APP_ADMIN_BASE_URL;

const redirectToMobile = async ({ contractType, builtForSection, openFor, documentId, offerId, propertyId, signatureInfo }) => {
  if (listingContractTypes.includes(contractType) || createOfferContractTypes.includes(contractType)) {
    const isSellerAgent = openFor === "SELLER_AGENT";
    const mobileDataToSend = {
      contractType,
      builtForSection,
      category: isSellerAgent ? "SELLER" : "BUYER",
      categoryId: isSellerAgent ? (listingContractTypes.includes(contractType) ? documentId : propertyId) : offerId,
    };
    if (!isSellerAgent && createOfferContractTypes.includes(contractType)) {
      mobileDataToSend.signed = Boolean(signatureInfo?.length);
    }
    await window?.ReactNativeWebView?.postMessage(JSON.stringify(mobileDataToSend));
  } else {
    await window?.ReactNativeWebView?.postMessage("WINDOW_CLOSED");
  }
};

export const handleClose = async ({ source, builtForSection, urlId, tabId, openFor, contractType, documentId, offerId, queryOrigin, clientId, propertyId, rootDocData, signatureInfo, history, readOnly, destination, email, omdUrlId }) => {
  // console.log("handleClose", source, builtForSection, urlId, tabId, openFor, contractType, documentId, offerId, queryOrigin, clientId, propertyId, rootDocData, signatureInfo, history, destination, email, omdUrlId);
  const {propertyData } = rootDocData || {};
  if ((source === "ContactSheet" && (readOnly || openFor === 'TITLE_COMPANY')) || (contractType === 'NET_SHEET' && rootDocData?.openFor === 'TITLE_COMPANY')) {
    history.push(`/success?client=true`);
    localStorage.removeItem(urlId);
    return;
  }
  if (queryOrigin === "true") {
    window.history.state ? window.history.back() : (window.location.href = omdUrlId && rootDocData?.offerId ? `${adminApiURL}/offer/${omdUrlId}/rtd/${rootDocData?.offerId}` : `${apiURL}`);
    localStorage.removeItem(urlId);
    return;
  }
  if (builtForSection === "DOCUMENT") {
    if (openFor === "BUYER" || openFor === "SELLER" || openFor === "BUYER_WITHDRAW") {
      if ([...customerDocsContractTypes, ...otherDocsContractTypes ].includes(contractType)) {
        history.push(`/success?client=true`);
      } else {
        window.location = `${apiURL}/clientScreen`;
      }
      localStorage.removeItem(urlId);
      return;
    }
    if (destination && ["SELLER_AGENT", "BUYER_AGENT"].includes(openFor)) {
    
      let localData = urlId ? JSON.parse(localStorage.getItem(urlId)) : {};
      const query = {
        ...(!["CONTACTS"].includes(destination) ? { role: openFor === "SELLER_AGENT" ? "sellerAgent" : "buyerAgent" } : {}),
        sessionId: ["TC_RTD", "TC_TRANSACTION", "TC_PRE_RTD", "TC_OMD"].includes(destination) && rootDocData.delegateId ? String(rootDocData?.delegateId || "") : String(rootDocData?.builtForId || ""),
        dest: destination,
        email,
        urlId: ["TC_RTD", "RTD", "PRE_RTD", "TC_PRE_RTD"].includes(destination) ? rootDocData?.offerId : ["TC_OMD", "OMD"].includes(destination) && omdUrlId ? omdUrlId : null,
        ...(["offerTable","OMD","TC_OMD"].includes(destination) ? { offerId: rootDocData?.offerId } : {}),
        ...(["TC_RTD", "TC_PRE_RTD"].includes(destination) ? { delegateOwnerId: rootDocData?.builtForId } : {}),
        ...(["CONTACTS"].includes(destination) ? { reqId: getPrimaryClientId(openFor === "BUYER_AGENT" ? localData.Buyers : localData.Sellers), key: "Docs" } : {}),
      };
      if (["transaction", "TRANSACTION", "TC_TRANSACTION"].includes(destination)) {
        const { category, categoryId } = getCategoryDataHandle({ rootDocData });
        query.category = category;
        query.categoryId = categoryId;
      }
      const queryString = buildQueryString(query);
      window.location.href = `${apiURL}/?${queryString}`;
      localStorage.removeItem(urlId);
      return;
    }
  }
  const isInWebView = detectWebView();
  if (isInWebView && source === "ShowEmailLogs" && (!tabId || !tabId.includes("_page2"))) { // from mobile direct open email logs page and close
    redirectToMobile({ contractType, builtForSection, openFor, documentId, offerId, propertyId, signatureInfo });
  }
  else if (isInWebView && source !== "ShowEmailContent") {
    redirectToMobile({ contractType, builtForSection, openFor, documentId, offerId, propertyId, signatureInfo });
  } else {
    const origin = await getValuesFromCookies(tabId);
    if (["ShowEmailContent", "ShowEmailLogs"].includes(source) && tabId?.includes("_page2")) tabId = tabId.replace("_page2", ""); // For TR report case
    // console.log("origin check", origin, clientId, apiURL);
    // return;
    switch (true) {
      case origin === "/transactions":
      case origin === "/account/delegates/transactions":
        if (openFor === "SELLER_AGENT") {
          if (listingContractTypes.includes(contractType)) {
            window.location.href = documentId ? `${apiURL}${origin}?category=SELLER&categoryId=${documentId}` : `${apiURL}${origin}`;
          } else {
            window.location.href = propertyId ? `${apiURL}${origin}?category=SELLER&categoryId=${propertyId}` : `${apiURL}${origin}`;
          }
        } else {
          window.location.href = offerId ? `${apiURL}${origin}?category=BUYER&categoryId=${offerId}` : `${apiURL}${origin}`;
        }
        break;
      case origin?.includes("/bDashboard"):
      case origin?.includes("/account/delegates/transactions/bDashboard"):
        if (clientId) {
          const ownerId = decryptUrlParams(clientId);
          clientId = encryptUrlParams(ownerId);
        }
        const refParam = clientId ? `?ref=${clientId}` : "";
        if (openFor === "BUYER_AGENT" && createOfferContractTypes.includes(contractType)) {
          if (!signatureInfo?.length) {
            if (origin?.includes("/account/delegates/transactions/bDashboard")) {
              window.location.href = `${apiURL}/account/delegates/transactions?category=BUYER&categoryId=${offerId}`;
            } else {
              window.location.href = `${apiURL}/transactions?category=BUYER&categoryId=${offerId}`;
            }
          } else {
            window.location.href = `${apiURL}${origin}${refParam}`;
          }
        } else {
          window.location.href = `${apiURL}${origin}${refParam}`;
        }
        break;
      case origin?.startsWith("/transactions/sDashboard"):
        // console.log("origin", origin);
        if(propertyData?.transactionType === "BUILDER") {
            window.location.href = `${apiURL}${origin}?type=BUILDER`;
        } else {
           window.location.href = `${apiURL}${origin}`;
        }
        break;
      case origin?.includes("/account/delegates/transactions/sDashboard"):
        if (clientId) {
          const ownerId = decryptUrlParams(clientId);
          clientId = encryptUrlParams(ownerId);
        }
        window.location.href = clientId ? `${apiURL}${origin}?ref=${clientId}` : `${apiURL}${origin}`;
        break;
      case origin?.startsWith("/offer/"):
        window.location.href = `${adminApiURL}${origin}`;
        break;
      case origin === "/contacts":
        window.location.href = clientId ? `${apiURL}${origin}?reqId=${clientId}&key=Docs` : `${apiURL}${origin}`;
        break;
      case origin?.includes("contractDocument"):
        if (["ShowEmailContent", "ShowEmailLogs"].includes(source) && !isInWebView) {
          window.location.href = `${adminApiURL}${origin}?tabId=${tabId}`;
        } else if (["ShowEmailContent", "ShowEmailLogs"].includes(source) && isInWebView) {
          try {
            window.history?.back();
          } catch (e) {
            window.location.href = apiURL;
          }
        }
        break;
      default:
        if (origin && origin !== "undefined" && origin !== "null") {
          window.location.href = `${apiURL}${origin}`;
        } else {
          try {
            window.history.back();
          } catch (e) {
            window.location.href = apiURL;
          }
        }
    }
  }
  localStorage.removeItem(urlId);
};
